<template>
  <div class="">
    <div class="ac">
      <el-select v-model="value.appInfoKey" placeholder="请选择" @remove-tag="clearData" multiple :multiple-limit="100"
        collapse-tags @change="changeOption" @focus="initOption" :style="styleObj">
        <!-- :popper-append-to-body="false" -->
        <div style="min-width: 400px">
          <el-row>
            <el-col :span="12" class="wrapper-left-box" v-infinite-scroll="load" :infinite-scroll-immediate="false"
              :infinite-scroll-distance="20">
              <div class="wrapper-left">
                <div class="left_title">
                  <el-button type="text" @click="AllOption">全选</el-button>
                  <el-button type="text" @click="backOption" :disabled="value.appInfoKey == 0 ? true : false">反选
                    <!--  -->
                  </el-button>
                </div>
                <div style="padding: 5px 20px">
                  <el-input size="mini" v-model.trim="inputval" @input="inputChange" />
                </div>
              </div>
              <!-- <div style="height:100px"></div> -->
              <template #prefix>
                <span v-if="systemIcon" class="iconfont" :class="systemIcon"></span>
              </template>
              <div class="box-wrapper">
                <!-- v-for="(item, index) in value.app ? value.app : data_show_arr" -->
                <!-- :disabled="item.shownothing" -->
                <el-option v-for="(item, index) in data_show_arr" :key="index" :value="item[prop_assign.key]"
                  :label="item[prop_assign.label]" class="options-wrapper">
                  <el-tooltip class="item" effect="dark" :content="item[prop_assign.label]" placement="right">
                    <div>
                      <span class="iconfont"
                        :class="[item.system ? formatSystemIcon(item.system) : '', item.shownothing ? 'shownothing' : '']">{{
        item[prop_assign.label]
      }}
                      </span>
                      <span v-if="item.subtitle" class="subtitle">{{
        item.subtitle
      }}</span>
                    </div>
                  </el-tooltip>
                </el-option>
              </div>
            </el-col>
            <el-col :span="12" class="wrapper-left-box">
              <div class="option_child" :key="num">
                <div class="title">
                  <span>已选择：{{
        value.optionList ? value.optionList.length : 0
      }} 条数据</span>
                  <el-button type="text" @click="cleanOption">清空全部</el-button>
                </div>
                <!-- <div style="height:50px"></div> -->
                <div v-for="(item, index) in value.optionList" :key="index" class="option_child_card">
                  <!-- <span class="iconfont" :class="item.system ? formatSystemIcon(item.system) : ''">{{ item.title  }}</span> -->
                  <div>
                    <span class="iconfont" :class="item.system ? formatSystemIcon(item.system) : ''">{{
        item[prop_assign.label] }}
                    </span>
                    <span v-if="item.subtitle" class="subtitle">{{
        item.subtitle
      }}</span>
                  </div>
                  <span class="el-icon-close del_option" @click="delOption(item[prop_assign.key], index)"></span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-select>
      <el-button type="primary" v-if="multipleFlag" @click="open" style="margin-left: 2px;height:40px;"
        size="mini">批量</el-button>
    </div>



    <el-dialog title="批量筛选" :visible.sync="dialogTableVisible" @close="cancel" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-input type="textarea" :rows="6" placeholder="请输入内容，回车分割" v-model="textarea" @input="search">
      </el-input>
      <el-button @click="clear" type="warning" plain style="margin-top:20px">清空</el-button>
      <el-divider>总共查询（{{ textarea_arr.length }}）；<span style="color:#409eff">搜索结果（{{
        compress_result.length
      }}）；</span><span style="color:#67c23a">已选择（{{ checkList.length }}）</span>
      </el-divider>
      <template v-if="compress_result.length > 0">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="checkList" @change="handleCheckedItem">
          <el-checkbox v-for="(item, index) in compress_result" :key="index" :label="item"></el-checkbox>
        </el-checkbox-group>
      </template>
      <div style="text-align:center" v-else>暂无相关渠道</div>

      <div>
        <el-button v-if="compress_result.length > 0" @click="confirm" type="primary" style="margin-top:20px">确定
        </el-button>
        <el-button @click="cancel" type="info" style="margin-top:20px">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from 'lodash'
export default {
  props: {
    value: {
      type: Object
    },
    // 原始数据
    data: {
      type: Array,
    },
    // 是否多选
    multipleFlag: {
      type: Boolean,
      default: false
    },
    // 组件的el-opetion 默认绑定的字段
    prop: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // style样式
    styleObj: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      timer: null,
      last_new_arr: [],
      num: 0, //更新组件的key
      loadNum: 0,  // 分页
      inputval: "",
      data_temp: [],  // 临时数据，如果是搜索就展示搜索的所有数据，如果没有搜索就是全部原始数据
      data_show_arr: [],  // 当前分页数据，每一页100条
      data_temp_chunk_arr: [],  // 把数组拆分为数组合集 [[],[],[],[]]这种 ；方便进行分页加载
      channelArrList: [], // 抽离title的数组
      // data_search_temp_chunk_arr: [], // 
      searchTimer: null,
      timer: null,   // 多选搜索防抖
      isIndeterminate: true,  // 多选是否默认全选
      checkAll: false,  // 是否全选
      checkList: [],  // 多选 选择的数据
      compress_result: [], // 多渠道筛选结果
      textarea: "",
      dialogTableVisible: false,
      textarea_arr: [] // 记录一下总共查询了多少
    };
  },
  computed: {
    prop_assign() {
      return Object.assign({
        key: 'id',  // 唯一标识
        label: "title",  // 显示
        outputField: 'id', // 输出的字段名称
        checkAllNumber: 2000, // 全选条数，默认2000，如果为0表示不限制
        changeDelay: 700
      }, this.prop)
    }
  },

  mounted() {
    this.num += 1;
  },
  methods: {
    // 批量筛选搜索
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        // 空格区分
        let textarea_arr = this.textarea.split(/[\n,]/g)
        // 去除字符串的空格
        let textarea_arr_replace = textarea_arr.map(e => {
          return e.replace(/\s*/g, "")
        })
        // 记录一下总共查询了多少
        this.textarea_arr = textarea_arr
        // 两个数组去对比相同的结果返回新的数组
        this.compress_result = _.compact(_.intersection(textarea_arr_replace, this.channelArrList))
        this.handleCheckAllChange(true)
      }, 300)
    },
    // 批量筛选全选
    handleCheckAllChange(val) {
      this.checkAll = true
      this.checkList = val ? this.compress_result : [];
      this.isIndeterminate = false;
    },
    // 批量筛选单选
    handleCheckedItem(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.compress_result.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.compress_result.length;
    },

    // 打开批量筛选
    open() {
      this.dialogTableVisible = true
    },
    // 确认
    confirm() {
      if (this.checkList.length == 0) return this.$message.info('请选择')
      this.dialogTableVisible = false
      this.$message.success('批量筛选成功，请点击查询')

      let appInfo = []
      let appInfoKey = []
      let optionList = []
      for (const el of this.data) {
        for (const _el of this.checkList) {
          // 批量搜索只查询和label一样的数据
          if (el[this.prop_assign.label] == _el) {
            appInfo.push(el[this.prop_assign.outputField])
            appInfoKey.push(el[this.prop_assign.key])
            optionList.push(el)
          }
        }
      }
      // 渲染组件
      this.value.appInfoKey = appInfoKey
      this.unityDealAppInfo({ isMutipleClick: true })

      // 更新父组件
      // this.$emit('update:value', {
      //   appInfoKey: appInfoKey,
      //   appInfo: appInfo,
      //   optionList: optionList
      // });
    },

    // 批量筛选清空
    clear() {
      this.textarea = ''
      this.checkList = ''
      this.compress_result = ''
      this.checkAll = false
    },

    // 批量筛选取消
    cancel() {
      this.dialogTableVisible = false
    },
    // 初始化多选搜索
    initMuitpleSearch() {
      this.textarea = ''
      this.textarea_arr = []
      this.checkList = []
      this.compress_result = []
      this.checkAll = false
    },
    // 数据分页加载
    load() {
      if (this.data_show_arr[0].shownothing) return  // 如果搜索无数据也会触发加载分页，所以此处需要判断一下
      if (this.loadNum < this.data_temp_chunk_arr.length - 1) {
        this.loadNum += 1
        this.data_show_arr = [...this.data_show_arr, ...this.data_temp_chunk_arr[this.loadNum]]
      }
    },

    // 点击选择
    changeOption() {
      this.unityDealAppInfo({
        disbaleUpdateList: true
      })
    },

    // 获取焦点事件
    async initOption() {
      this.num += 1;
    },

    // 统一处理value相关的数据,根据appkeyInfo回显
    /**
     * 
     * params.initFlag  是否为父组件初始化数据
     * params.isMutipleClick 是否为批量筛选点击确认触发
     */
    unityDealAppInfo(params = {}) {
      const { prop_assign } = this

      if (!params.isMutipleClick) {
        // 把多选重置
        this.initMuitpleSearch()
      }

      // 统一处理appinfo和optionList
      return new Promise((resolve) => {
        let arr = [];
        let appInfo = []
        this.data.forEach((item) => {
          this.value.appInfoKey.forEach((_item) => {
            if (item[prop_assign.key] == _item) {
              arr.push(item);
              appInfo.push(item[prop_assign.outputField])
            }
          });
        });
        this.value.optionList = arr;
        this.value.appInfo = appInfo;
        // 当最新的数据临时存起来
        this.last_new_arr = appInfo

        // 处理选中的第一条数据，并判断是否在el-option列表中
        this.dealOptionListFirst(this.data_temp, params)

        // 给父组件传递change事件
        if (!params.initFlag) {
          this.emitParentsChange()
        }
        resolve(true)
      })
    },

    // 获取选中的第一条数据，目的是为了再列表里面加上此数据，防止列表中没有不显示名称

    /**
     * 
     * disbaleUpdateList  禁止重新对data进行分组
     */
    async dealOptionListFirst(arr_temp = [], params = {}) {
      let arr = _.cloneDeep(arr_temp)
      if (arr && arr.length == 0) {
        this.data_show_arr = []
      } else if (!params.disbaleUpdateList) {
        // 初始化data数据
        await this.initListData(arr)
      }


      // 查询选中的最后一条数据是否在筛选列表中
      let firstAppInfoKey = this.value.appInfoKey && this.value.appInfoKey.length > 0 ? this.value.appInfoKey.at(0) : null;

      if (firstAppInfoKey) {
        // 选择的第一条数据在全部data里面的索引
        const idx = this.data.findIndex((el) => el[this.prop_assign.key] == firstAppInfoKey);

        // 判断选择的第一条数据是否在当前处理的arr数组中
        const in_arr_index = this.data_show_arr.findIndex((el) => el[this.prop_assign.key] == firstAppInfoKey)

        if (idx > -1 && in_arr_index == -1) {

          // 找到选择第一个数据在原始数据中的位置，放到第一位
          this.data_show_arr.unshift(this.data[idx])

        }
      }
    },

    // 初始化列表数据
    initListData(arr) {
      return new Promise((resolve, reject) => {
        this.loadNum = 0
        this.data_temp_chunk_arr = _.chunk(arr, 100)
        this.data_show_arr = this.data_temp_chunk_arr[0]
        resolve(true)
      })
    },

    // 选择全部app 同时映射左右列表
    AllOption() {
      // 如果checkAllNumber == 0 表示不受限制
      if (this.prop_assign.checkAllNumber > 0 && this.data_temp.length > this.prop_assign.checkAllNumber) return this.$message.warning(`最大全选数量为${this.prop_assign.checkAllNumber}条`)
      let appInfoKey = [];
      for (const i of this.data_temp) {
        appInfoKey.push(i[this.prop_assign.key]);
      }
      let arr = this.value.appInfoKey.concat(appInfoKey);
      arr = [...new Set(arr)]
      this.value.appInfoKey = arr
      // 统一处理右侧渲染数据
      this.unityDealAppInfo({
        disbaleUpdateList: true
      })
    },

    // 下拉筛选手动输入查询
    inputChange() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(() => {
        if (this.inputval === '') {
          this.data_temp = _.cloneDeep(this.data);
          this.dealOptionListFirst(this.data_temp);
        } else {
          // 去掉首尾空格
          let inputV = this.inputval.trim();
          //使用过滤函数筛选出匹配的数据项
          let arr = this.data.filter(item => this.doesItemMatch(item, inputV));
          console.log(arr)
          if (arr.length) {
            this.data_temp = arr;
            this.dealOptionListFirst(arr);
          } else {
            let temp = [{
              title: `没有搜索到相关数据~`,
              id: '-100',
              shownothing: true
            }];
            this.data_temp = [];
            this.dealOptionListFirst(temp);
          }
        }
      }, 300);
    },

    doesItemMatch(item, input) {
      let labelMatch = false;
      let subtitleMatch = false;
      // 检查主标签是否匹配输入
      if (item[this.prop_assign.label]) {
        labelMatch = this.doesStringMatch(item[this.prop_assign.label], input);
      }
      // 检查副标题是否匹配输入
      if (item.subtitle) {
        subtitleMatch = this.doesStringMatch(item.subtitle, input);
      }

      return labelMatch || subtitleMatch;
    },

    doesStringMatch(str, input) {
      str = str + ''
      // 将字符串和输入都转换为小写
      str = str.toLocaleLowerCase();
      input = input.toLocaleLowerCase();

      return str.includes(input);
    },

    // 清除左右列表
    cleanOption() {
      this.initMuitpleSearch()
      this.value.appInfoKey = [];
      this.value.appInfo = [];
      this.value.optionList = [];
      // 当最新的数据临时存起来
      this.last_new_arr = []
      // 通知父组件
      this.emitParentsChange()
      /*      this.$emit('clearData') */
    },

    // 反选
    backOption() {
      let appInfoKey = [];
      let appInfo = [];
      let optionList = [];
      let defference = this.data_temp.filter(
        (v) => this.value.appInfoKey.indexOf(v[this.prop_assign.key]) == -1

      );
      // 如果checkAllNumber == 0 表示不受限制
      if (this.prop_assign.checkAllNumber > 0 && defference.length > this.prop_assign.checkAllNumber) return this.$message.warning(`最大全选数量为${this.prop_assign.checkAllNumber}条`)

      if (defference.length) {
        /* defference.forEach((item) => {
          appInfoKey.push(item[this.prop_assign.key]);
          optionList.push(item);
        }); */
        for (let index = 0; index < defference.length; index++) {
          const el = defference[index]
          appInfoKey.push(el[this.prop_assign.key]);
          appInfo.push(el[this.prop_assign.outputField]);
          optionList.push(el);
        }
        this.value.appInfoKey = appInfoKey;
        this.value.appInfo = appInfo;
        this.value.optionList = optionList;
        // 当最新的数据临时存起来
        this.last_new_arr = appInfo
      } else {
        this.value.appInfoKey = [];
        this.value.appInfo = [];
        this.value.optionList = [];
        // 当最新的数据临时存起来
        this.last_new_arr = []
      }
      // 通知父组件
      this.emitParentsChange()
      this.initMuitpleSearch()
    },

    // 删除右边所选项 同步更新左右列表
    delOption(id, index) {
      const idx = this.value.appInfoKey.findIndex((el) => el == id)
      if (idx > -1) {
        this.value.appInfoKey.splice(idx, 1)
        this.value.appInfoKey = _.cloneDeep(this.value.appInfoKey)
      }
      // 统一处理value相关的数据
      this.unityDealAppInfo()
    },

    // 格式化列表图标
    formatSystemIcon(code) {
      switch (String(code)) {
        case "1":
          return "icon-anzhuo";
        case "2":
          return "icon-ios";
        case "3":
          return "icon-weixin";
        case "4":
          return "icon-douyin";
        case '5':
          return 'icon-chrome'
        case '6':
          return 'icon-hongmeng';
        default:
          return "";
      }
    },

    // 清空单条数据
    clearData() {
      // 给父组件传递消息
      this.emitParentsChange()
      // if (this.value.appInfoKey.length == 0) {
      //   this.$emit("clearData");
      // }
    },

    // 判断两个数组数据是否相同，不分顺序
    equarArrFun(arr1, arr2) {
      let flag = true
      if (arr1.length !== arr2.length) {
        flag = false
      } else {
        for (const item of arr1) {
          if (arr2.indexOf(item) == -1) {
            flag = false
            return false
          }

        }
      }
      return flag;
    },

    // 给父组件传递change事件
    emitParentsChange() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.$emit("changeScope", this.value);
      }, this.prop_assign.changeDelay || 400);
    }

  },

  watch: {
    data: {
      handler: function (val) {
        this.data_temp = _.cloneDeep(val)
        // 初始化数据，对数据进行分页
        this.initListData(val)

        /**
         * 这里是为了渠道号多选，单独把所有的渠道号抽离成一个数组，方便批量筛选
         * 结果如下 ['A','B']
         *  */
        if (this.multipleFlag) {
          this.channelArrList = _.flatMap(this.data_temp, n => [n[this.prop_assign.label]])
        }
      },
      immediate: true,
      deep: true
    },
    // 监听选择数据的变化，根据父组件传递的参数返回对应的字段，比如说父组件传递的是id,此处就给父组件返回id 参数props中的 prop_assign
    /**
     * appInfoKey 原始的id，用来回显，这里绑定是什么值这里面就存什么值
     * appInfo  输出的数据值，如果需要输出title，这里面的存的是title
     * last_new_arr 用来存储最近一次组件内最新的数据
     */
    'value': {
      handler: async function (newval) {
        // 如果父组件不传递appInfoKey字段，第一次进来就默认等于appInfo

        /**
         * 有四种情况
         * 1、初始状态下没有appInfoKey或者是appInfoKey为空数字
         * 2、appInfo为空数组表示第一次进来或者是后续对组件进行中重置操作
         * 3、在父组件中对appInfo进行重新赋值，通过判断上一次存储的最新数据last_new_arr是否和appInfo相等，如果不等说明就是重置了，
         * 需要重新处理数据
         */
        //  初始化默认值
        newval.appInfoKey = newval.appInfoKey || []
        newval.optionList = newval.optionList || []

        // 先判断数据是否一致，如果为true先阻断，不然会进入死循环
        if (this.equarArrFun(this.last_new_arr, newval.appInfo)) return
        if (newval.appInfo && newval.appInfo.length > 0) {
          newval.appInfoKey = newval.appInfo
          // 如果第一次进来的数据不为空表示需要回显
          await this.unityDealAppInfo({
            initFlag: true  // 初始化数据的时候
          })
        } else {
          // 如果传递来的是空数组，可能是第一次进入，也可能是选择关联数据之后再次情况需要重置
          newval.appInfoKey = []
          newval.optionList = []
          this.inputval = ''
          // 这里需要重置一下组件的data数据
          this.emitParentsChange()
          setTimeout(() => {
            this.initListData(this.data)
          }, 100);
        }

        /**
         * 备份 ↓
         */

        // if (newval.appInfo && newval.appInfo.length > 0) {
        //   // !newval.appInfoKey || newval.appInfoKey.length == 0 || newval.appInfo.length == 0
        //   newval.appInfoKey = newval.appInfo
        //   // 如果第一次进来的数据不为空表示需要回显
        //   if (newval.appInfoKey && newval.appInfoKey.length > 0) {
        //     await this.unityDealAppInfo({
        //       initFlag: true  // 初始化数据的时候
        //     })
        //   } else {
        //     // 初始化
        //     newval.optionList = []
        //     this.inputval = ''
        //     this.initListData(this.data)
        //   }
        // }
      },
      deep: true,
      immediate: true
    },

  },
};
</script>

<style lang="less" scoped>
/deep/ .el-scrollbar {
  min-width: 450px;
}

/deep/.el-select-dropdown__item.selected {
  .iconfont {
    font-weight: normal;
  }
}

/deep/.iconfont {
  font-weight: normal;
}

.left_title {
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  line-height: 40px;
}

.option_child {
  padding: 0 20px;

  .option_child_card {
    .del_option {
      cursor: pointer;
      padding: 5px;
    }

    display: flex;
    justify-content: space-between;
    background: rgb(240, 240, 240);
    padding: 15px 10px;
    margin: 10px 0;
    border-radius: 10px;
  }

  .title {
    font-size: 14px;
    display: flex;
    justify-content: space-around;
    line-height: 40px;
    position: sticky;
    width: 100%;
    margin-top: -5px;
    margin-bottom: 20px;
    top: 0;
    background: #FFF;
  }
}

.sub-title {
  font-size: 13px;
  color: #999;
  font-weight: normal;
}

.options-wrapper {
  height: auto !important;
}

.subtitle {
  display: block;
  color: #999;
  font-weight: normal;
}

.options-wrapper::after {
  top: 50% !important;
  transform: translateY(-50%);
}

.wrapper-left-box {
  height: 245px;
  overflow-y: scroll;
  position: relative
}

.wrapper-left {
  position: sticky;
  z-index: 99;
  background: #FFF;
  width: 100%;
  top: 0;
  margin-top: -5px;
  margin-bottom: 20px;
}

.shownothing {
  font-size: 12px !important;
  color: #999 !important;
}

.select-wrapper {
  // width: 75%;
}

.w100 {
  width: 100%;
}

.ac {
  display: flex;
  align-items: center;
}
</style>